import PropTypes from 'prop-types';
import EcomEngineAPI from 'api/ecom_engine_api';

export function Logout({ className }) {
  const useLogout = () => {
    EcomEngineAPI.account.logout().then(() => window.location.assign('/'));
  };

  return (
    <a className={className} onClick={useLogout} href="#">
      Logout
    </a>
  );
}

Logout.propTypes = {
  className: PropTypes.string,
};

export default Logout;
